import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Styles from '../Style/Common.module.css';
import BtnStyle from '../Style/Button.module.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import parse from 'html-react-parser';
//icon
import { RxArrowTopRight } from "react-icons/rx";
//image api
import constants from "../../services/constants";

const TQservices = ({ data }) =>{

  const serviceSlide = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  return(
    <div className={'servicesBlock ' + Styles.servicesSec + " " + Styles.blueSecBlock}>
      <Container fluid>
        <Row>
          <Col>
            <div className={Styles.servicesContainer}>
              <h2 className={Styles.title} data-aos="fade-up" data-aos-delay="200">Services</h2>
              <p className={Styles.subTitle} data-aos="fade-up" data-aos-delay="500">Enabling a Safer, Smarter, and Sustainable Future</p>
            </div>
          </Col>
        </Row>
        <Row className={Styles.servicesContainer + " " + Styles.topSpace}>
          {data && data.sort((a, b) => a.order - b.order).map((item, index) => (
            <Col className={Styles.mobileCol} key={index} data-aos="fade-up" data-aos-delay={index * 200}>
              <div className={Styles.serviceItem}>
                <div className={Styles.itemBox}>
                  <img src={`${constants.Image_BASE_URL}${item.image}`} alt={item.title} />
                  <div className={Styles.content}>
                    <h3>{item.title}</h3>
                    {parse(item.description)}
                    {/* <Link to={item.link} className={BtnStyle.roundBtnLg + ' ' + BtnStyle.RoundRed}>
                        <RxArrowTopRight />
                    </Link> */}
                    {item.link =="assurance-services" && <Link to="assurance-service" title={item.link} className={BtnStyle.roundBtnLg + ' ' + BtnStyle.RoundRed}><RxArrowTopRight /></Link>}
                    {item.link =="project-services" && <Link to="project-services" title={item.link} className={BtnStyle.roundBtnLg + ' ' + BtnStyle.RoundRed}><RxArrowTopRight /></Link>}
                    {item.link =="certification-and-technical-services" && <Link to="certification-technical-services" title={item.link} className={BtnStyle.roundBtnLg + ' ' + BtnStyle.RoundRed}><RxArrowTopRight /></Link>}
                  </div>
                </div>
              </div>
            </Col>
          ) )}
   
        </Row>
      </Container>
    </div>
  )
}

export default TQservices;